import * as React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeConfigurations } from '../../utils/Configuration/FontAwesomeConfiguration';

const Path = props => <motion.path fill="transparent" strokeWidth="3" stroke="#fff" strokeLinecap="round" {...props} />;

export const MenuToggle = ({ toggle, isOpen }) => (
  <div className={`stream_chat_pane_toggle`} onClick={toggle}>
    <motion.div variants={toggleVariants} animate={isOpen ? 'visible' : 'hidden'} initial={'hidden'}></motion.div>
    <motion.div variants={toggleVariants} animate={!isOpen ? 'visible' : 'hidden'} initial={'visible'}>
      <i className={FontAwesomeConfigurations.ICON_COMMENTS_DUOTONE} />
    </motion.div>
  </div>
);

const toggleVariants = {
  hidden: {
    scale: 0,
    opacity: 0,
    transition: {
      delay: 0,
    },
  },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      delay: 0.3,
    },
  },
};
